import { ensureError, isTruthy } from '@fabric-app/utils/guards';
import { getCompatFile, UploadStatus } from '@fabric-app/compat/capabilities/file';
import { UploadErrorCode } from '@fabric-app/types/upload';
import { UploadError } from '../upload.error.js';

const executeNativeUpload = async ({ method, url, headers, onProgress, abortSignal, data, chunk }) => {
  const fileCompat = getCompatFile();
  if (!fileCompat.getIsAvailable()) throw new UploadError(UploadErrorCode.FileNotAvailable);
  return await new Promise((resolve, reject) => {
    fileCompat.uploadFile({
      uploadUrl: url,
      fileUri: data.file.uri,
      headers,
      method,
      chunkSize: chunk?.size,
      chunkIndex: chunk?.index
    }, (uploadProgress, err) => {
      if (abortSignal.aborted) {
        reject(new UploadError(UploadErrorCode.FileUploadCancelled));
        return;
      }
      if (err) {
        reject(ensureError(err));
        return;
      }
      if (!uploadProgress) return;
      if (uploadProgress?.status === UploadStatus.ERROR) {
        reject(ensureError(uploadProgress.message));
        return;
      }
      if (uploadProgress?.status === UploadStatus.COMPLETED) {
        onProgress?.(100, 0);
        const headers2 = Object.fromEntries(Object.entries(uploadProgress.responseHeaders ?? {}).filter(([, value]) => isTruthy(value)).map(([key, value]) => [
          key.toLowerCase(),
          value
        ]));
        resolve({
          responseHeaders: headers2
        });
        return;
      }
      onProgress?.(uploadProgress.progress, uploadProgress.uploadSpeed);
    });
  });
};

export { executeNativeUpload };
//# sourceMappingURL=executeNativeUpload.js.map
